import React,{useEffect} from 'react'
import { useHistory } from 'react-router'
import { useDispatch } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';

export default function Logout() {

    const history = useHistory()
	const dispatch = useDispatch();
            dispatch({
                type: 'SIGN_OUT',
                payload: null,
            });
            history.push('/login');
    return (
        <div>
            <ToastContainer />
        </div>
    )
}
